function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as storeBrandApi from '@/api/storeBrandApi.js';
import { Debounce } from '@/utils/validate';
export default {
  components: {},
  props: {
    // 默认商品类型，1-实物商品，2-卡劵商品
    defaultProductType: {
      type: Number,
      default: null
    },
    // 默认状态，1-启用，0-禁用
    defaultStatus: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {
        id: null,
        productType: null,
        brandName: '',
        status: null,
        brandLogo: '',
        // 供应商版本保留字段但不显示
        brandRemark: '' // 供应商版本保留字段但不显示
      },
      brandOption: []
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit(id) {
      var _this = this;
      if (!id) {
        // 新增时，设置默认值，供应商版本清空logo和简介
        this.pram = {
          id: null,
          productType: this.defaultProductType !== null ? this.defaultProductType : null,
          brandName: '',
          status: this.defaultStatus !== null ? this.defaultStatus : null,
          brandLogo: '',
          // 供应商版本始终为空
          brandRemark: '' // 供应商版本始终为空
        };
        this.visible = true;
        return;
      }
      ;
      storeBrandApi.getBrandInfo(id).then(function (res) {
        _this.pram = _objectSpread({}, res);
        // 供应商版本编辑时也清空logo和简介
        _this.pram.brandLogo = '';
        _this.pram.brandRemark = '';
        _this.visible = true;
      });
    },
    handerSubmit: Debounce(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        // 供应商版本提交前确保logo和简介为空
        _this2.pram.brandLogo = '';
        _this2.pram.brandRemark = '';
        _this2.loading = true;
        storeBrandApi[_this2.pram.id ? 'UpdateArticle' : 'AddArticle'](_this2.pram).then(function (data) {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};